module.exports = "/_next/static/images/64464c82a4d5675067be437557e5ec1a-purple-man@0.5x.jpg";